import { motion } from 'framer-motion';
import { customEasing } from '../lib/easing';

const methods = [
  'Empirical literature synthesis',
  'Primary-source analysis',
  'Case-study reporting',
  'Deployment and risk framing',
];

function TeamSection() {
  return (
    <section id="team" className="section-asi bg-white">
      <div className="container-asi">
        <motion.div
          initial={{ opacity: 0, y: 32 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: '-100px' }}
          transition={{ duration: 0.7, ease: customEasing.smooth }}
          className="grid gap-10 md:grid-cols-[0.75fr_1fr]"
        >
          <div>
            <p className="mb-3 text-xs font-semibold uppercase tracking-[0.2em] text-asi-copper">
              Institute Model
            </p>
            <h2 className="font-serif text-3xl text-asi-navy md:text-4xl">
              Independent research for decisions that cannot wait for consensus
            </h2>
          </div>

          <div className="border border-slate-200 bg-[#fbfbfa] p-5 md:p-7">
            <h3 className="mb-4 font-serif text-2xl text-asi-navy">
              About AI Studies Institute
            </h3>
            <p className="text-base leading-8 text-slate-700">
              AI Studies Institute publishes rigorous, readable research on
              where AI changes outcomes: individual productivity variance,
              real-world robotics deployment, high-stakes implementation risk,
              and the gap between public perception and technical capability.
            </p>
            <p className="text-base leading-8 text-slate-700">
              The institute is based in Research Triangle Park, North Carolina,
              and focuses on evidence synthesis that can inform funding,
              policy, workforce, and deployment choices.
            </p>

            <div className="mt-7 border-t border-slate-200 pt-6">
              <p className="mb-4 text-sm font-semibold uppercase tracking-[0.18em] text-slate-500">
                Method
              </p>
              <div className="grid gap-3 sm:grid-cols-2">
                {methods.map((method) => (
                  <div
                    key={method}
                    className="border border-slate-200 bg-white px-4 py-3 text-sm font-medium text-slate-700"
                  >
                    {method}
                  </div>
                ))}
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
}

export default TeamSection;
